import { generatePath, matchPath } from 'react-router-dom';
import PATHS from '../../Routers/PATHS';
import { Consts } from '../../res/Consts';

const KNOWLEDGE_TYPES = new Set([Consts.EXAM_TYPES.TEST_MCQS, Consts.EXAM_TYPES.TEST_ESSAY,
    Consts.EXAM_TYPES.TEST_TBS, Consts.EXAM_TYPES.TEST_FILE]);
const validId = value => /^[1-9]\d*$/.test(value || '') && Number.isSafeInteger(Number(value));

// Store IDs in the exam URL so refreshing or resuming the same page retains
// the source section. Build only a book route belonging to the current exam.
export const getBookExamReturnPath = (location, exam, selectedCourseId) => {
    if (!location || exam?.isViewOnly || !KNOWLEDGE_TYPES.has(exam?.examType)) return null;
    const match = matchPath(location.pathname, { path: PATHS.USER_TEST_KNOWLEDGE_EXAM.URL, exact: true });
    const query = new URLSearchParams(location.search);
    const courseId = query.get('courseId');
    const sectionId = query.get('bookSectionId');
    const topicId = query.get('topicId');
    if (!match || ![courseId, sectionId, topicId].every(validId)
        || courseId !== String(selectedCourseId) || topicId !== String(exam.topicId)
        || match.params.topicId !== topicId || match.params.examType !== exam.examType) return null;
    return `${generatePath(PATHS.USER_COURSE_BOOK.URL, { courseId })}?sectionId=${sectionId}`;
};
